import { style } from '@primeuix/styles/radiobuttongroup';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-radiobutton-group p-component'
};
var RadioButtonGroupStyle = BaseStyle.extend({
  name: 'radiobuttongroup',
  style: style,
  classes: classes
});

export { RadioButtonGroupStyle as default };
//# sourceMappingURL=index.mjs.map
